<template>
  <div
    class="tw-notification-container border-bottom p-3"
    :class="'tw-notification-status-' + notification.status.resourceUid"
  >
    <div class="tw-notfication-actions">
      <span
        class="p-0 text-primary bg-transparent cursor-pointer"
        @click="showTransfer = !showTransfer"
      >
        {{ $t("communication.comNotification.transferBtn") }}
      </span>
    
      <span
        class="p-0 text-primary bg-transparent cursor-pointer"
        @click="
          (showRepondre = !showRepondre),
            (msgUID = notification.resourceUid),
            (sender = notification.sender),
            (priority = notification.priority),
            (subject = notification.subject),
            (type = notification.type),
            (senderUid = notification.senderUid),
            (reference = notification.reference),
            (metadata = notification.metadata)
        "
      >
        {{ $t("communication.comNotification.respondBtn") }}
      </span>
      
      <span
        class="p-0 text-primary bg-transparent cursor-pointer"
        @click.stop="updateState({ index, notification, ActionType: 'Delete' })"
      >
        {{ $t("communication.comNotification.deleteBtn") }}
      </span>
    </div>

    <div
      class="tw-notfication-content"
      @click.stop="updateState({ index, notification, ActionType: 'ChangeStatus' })"
    >
      <div class="align-items-center d-flex">
        <span class="font-size-14 font-medium">
          <!-- {{ notificationSubject }} -->
          {{ getNotification().subject?.resourceUid }}
        </span>
        <span
          v-if="getNotification().priority"
          class="badge badge-danger ml-1 p-1 small"
          style="font-size: 10px"
        >
          Important
        </span>
      </div>
      <div class="mb-2">
        <span class="text-muted" v-if="getNotification().communicationDate">
          {{ formateCommunicationDate }} -
        </span>

        <span class="font-medium">
          {{ getNotification().sender }}
        </span>
      </div>
      <div class="mb-2">
        <span  v-for="(ref, index) in getEntityReferences()"
               :key="index"
          class="badge bg-grey-12 mr-2"
          @click="openNewTab(ref, statusUID ,context)"
        >
          {{ ref }}
        </span>
       <!--
        <span class="badge badge-warning" v-if="checKContextEntityStatus">
          {{ entityStatus }}
        </span>
       
        <span class="badge bg-grey-12 mr-2g">
          {{ context }}
        </span>
        -->
        <span v-for="tag in notificationMetadataTags" :key="tag.key" class="badge bg-grey-12 mr-2">
          {{ tag.label }}: {{ tag.value }}
        </span>
      </div>
      <div
        class="bg-white p-2 border default-border-radius tw-notification-comment-wrapper"
        v-if="!showRepondre && !showTransfer"
      >
        <span class="d-flex" :class="showComment ? '' : 'tw-trancate-text-comment'">
          {{ showComment ? getNotification().body : truncatedText(getNotification().body) }}
        </span>
        <span v-if="isLongText()">
          <button
            class="btn p-0 bg-transparent text-primary"
            style="text-decoration: underline !important"
            @click="showComment = !showComment"
          >
            {{
              !showComment
                ? $t("communication.comNotification.showMore")
                : $t("communication.comNotification.showLess")
            }}
          </button>
        </span>
      </div>
      <div
        v-if="showRepondre && !showTransfer"
        class="bg-white default-border-radius p-1 pl-0 pr-0"
      >
        <form @submit.prevent="submitFormTransfert">
          <textarea v-model="msgSend" class="w-100 border"></textarea>
        </form>
        <div class="d-flex justify-content-end align-items-center">
          <button
            class="btn bg-transparent text-dark mr-2"
            type="button"
            @click="cancelFormRepondre"
            filled
          >
            {{ $t("communication.comNotification.cancelBtn") }}
          </button>
          <button class="btn btn-primary" type="submit" @click="messageReplyMethode">
            {{ $t("communication.comNotification.sendBtn") }}
          </button>
        </div>
      </div>
      <div v-if="showTransfer" class="bg-white p-1 default-border-radius">
        <form @submit.prevent="submitFormRepondre">
          <div class="row form-group">
            <combo-recipients
              ref="comboRecipients"
              :recipients="destinataires"
              :metadata="notification.metadata"
            />

            <div
              class="col-lg-12 col-md-12 col-sm-12 form-control no-border font-size-12"
            >
              {{ $t("communication.comNotification.valueOfRecipient") }}:
            </div>
          </div>
        </form>
        <div class="d-flex justify-content-end align-items-center">
          <button
            class="btn bg-transparent text-dark mr-2"
            type="reset"
            @click="cancelFormTransfert"
          >
            {{ $t("communication.comNotification.cancelBtn") }}
          </button>

          <button class="btn btn-primary" type="submit" @click="submitFormTransfert">
            {{ $t("communication.comNotification.sendBtn") }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <q-inner-loading
    :showing="showInner"
    :label="$t('communication.comMessage.waitSendMessageLabel')"
    label-class="text-blue"
    label-style="font-size: 1.1em"
  />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapActions} from "vuex";
import i18n from "@/i18n";
import store from "@/store";
import ComboRecipients from "@/components/communication/comboRecipients.vue";

import {
  _parameters,
  clientAppMsg,
  messageTemplate,
  objectType_odmTransferReplyMsg,
  OfferStatus,
  recipient,
  transferMsg,
  User,
} from "@/types";
import { convertToUON, notifyReplytransferMsg } from "@/utils";
import router from "@/router";

@Options({
  name: "MessageCom",
  components: {
    ComboRecipients,
  },
  props: {
    notification: {
      type: Object,
      default: () => ({}), // set default value as an empty object
    },
    destinataires: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0, // set default value as 0
    },
  },
  computed: {
    /**
     * translating notification Subject
     */
    notificationSubject() {
      return i18n.global.t(`enum.offer.status.${this.notification.subject?.resourceUid}`);
    },
    /**
     *  reformate CommunicationDate to JJ/MM/AAAA
     */
    formateCommunicationDate() {
      return new Date(this.notification.communicationDate).toLocaleString("fr-FR");
    },
    /**
     * display condition for entity_status only if context is 'OFFER' and not undefined/null
     */
    checKContextEntityStatus() {
      return (
        this.notification.metadata?.length > 0 &&
        this.notification.metadata?.find((meta: any) => meta.key === "Context")?.value !==
          "PARTY" &&
        this.notification.metadata?.find((meta: any) => meta.key === "Entity_Status")
          ?.value !== "undefined"
      );
    },
    /**
     * translating notification entity_status
     */
    entityStatus() {
      if( this.notification.metadata?.find((meta: any) => meta.key === "Entity_Status")?.value !='null'){
        if(this.notification.metadata?.find((meta: any) => meta.key === "Context")?.value ==='OFFER'){
          return i18n.global.t(
          `enum.offer.status.${
          this.notification.metadata?.find((meta: any) => meta.key === "Entity_Status")
            ?.value
          }`);
        }else if (this.notification.metadata?.find((meta: any) => meta.key === "Context")?.value ==='ORDER'){
          return i18n.global.t(
          `main.dossier.orderStatus.${
          this.notification.metadata?.find((meta: any) => meta.key === "Entity_Status")
            ?.value
          }`);
        }else {
          return this.notification.metadata?.find((meta: any) => meta.key === "Entity_Status")
            ?.value   
        } 
      }
      return ''
    },
    /**
     * fetching and displaying entity_reference
     */
    entityReference() {
      if( this.notification.metadata?.find((meta: any) => meta.key === "Entity_Reference")?.value !='null'){
      return this.notification.metadata?.find(
        (meta: any) => meta.key === "Entity_Reference"
      )?.value;
    }
    return ''
  },

    notificationMetadataTags() {
      const metadata = this.notification?.metadata ?? [];
      const definitions = [
        { key: "Entity_ExternalReference", label: "Réf. ext" },
        { key: "Entity_AssociatedPartyName", label: "Client" },
        { key: "Entity_SellerName", label: "Vendeur" },
        { key: "Entity_NumFabrication", label: "N° de fabrication" },
        { key: "Entity_Brand", label: "Marque" },
        { key: "Entity_Ranges", label: "Gamme" },
        { key: "Entity_Versions", label: "Version" },
      ];

      return definitions
        .map(({ key, label }) => {
          const value = metadata.find((meta: any) => meta.key === key)?.value;
          if (!value || value === "null" || value === "undefined") {
            return null;
          }
          return { key, label, value: String(value).trim() };
        })
        .filter((item): item is { key: string; label: string; value: string } => !!item);
    },

    context() {
      if( this.notification.metadata?.find((meta: any) => meta.key === "Context")?.value !='null' && 
          this.notification.metadata?.find((meta: any) => meta.key === "Entity_Reference")?.value !== undefined){
      return this.notification.metadata?.find(
        (meta: any) => meta.key === "Context"
      )?.value;
    }
    return ''
  },

    entityRessourceUID() {
      if(this.notification.metadata?.find((meta: any) => meta.key === "Context")?.resourceUid!='null'){
          return this.notification.metadata?.find((meta: any) => meta.key === "Context")
        ?.resourceUid
        }
        return ''
    },
    statusUID() {
      if(this.notification.metadata?.find((meta: any) => meta.key === "Entity_Status")?.value!='null'){
        return this.notification.metadata?.find((meta: any) => meta.key === "Entity_Status")
        ?.value
      }
      return '';
    },
  },

  methods: {
    ...mapActions("notificationModule", ["updateState", "setMsgUID", "transferMessage"]),
    ...mapActions("notificationModule", ["updateState"]),
    /**
     * This function retrieves the selected tag in the given scope.
     @param {any} scope - The scope to retrieve the selected tag.
     @returns {string} - The selected tag in the given scope.
     */
    getSelectedLabel(scope: any) {
      if (scope.opt.id) {
        return {
          id: scope.opt.reference ? scope.opt.reference : scope.opt.id,
          context: "Party",
        };
      } else if (scope.opt.reference) {
        return {
          id: scope.opt.reference,
          context: "Offer",
        };
      } else if (scope.opt.referenceorder) {
        return {
          id: scope.opt.referenceorder,
          context: "Order",
        };
      }
    },

    /**
     * get selected notif
     */
    getNotification() {
      return this.notification;
    },

    /**
     * get destinations from comboRecipients
     */
    getOdmRecipients() {
      const _destinations = convertToUON(this.$refs.comboRecipients.destinations);

      return _destinations;
    },
    /**
     * get entity reference as an array
     */
    getEntityReferences() {
      if (!this.entityReference) {
        return [];
      }
      if (this.entityReference.includes(',')) {
       var ssss =  this.entityReference.split(',');
       console.log(ssss);
       return ssss;
      }

      return [this.entityReference];
    },

    getReplyRecipientUid() {
      const currentUserId = store.state.authModule?.user?.userId;
      const notificationSenderUid = this.notification.senderUid?.resourceUid || this.notification.senderUid;
      if (notificationSenderUid && notificationSenderUid !== currentUserId) {
        return notificationSenderUid;
      }
      const recipients = this.notification.recipients || [];
      const other = recipients.find(
        (r: any) => (r.recipient?.resourceUid || r.resourceUid) !== currentUserId
      ) || recipients[0];
      return other?.recipient?.resourceUid || other?.resourceUid;
    },

    /**
     * mapping parameters from metadata
     * TODO: fix mapping metadata using parameters (reply transfer msg)
     */
    getParams() {
      const _metadata = this.getNotification().metadata;
      const _params = _metadata.reduce(
        (_params: any, meta: { key: string; value: any }) => {
          if (meta.key in _params) {
            return { ..._params, [meta.key]: meta.value };
          }
          return _params;
        },
        { Context: "", Entity_Reference: "", Entity_Status: "", Entity_Id: "" }
      );
      return _params;
    },
  },
})
export default class Notification extends Vue {
  notification!: Notification;
  messageTransfer!: User;
  ActionType!: string;
  status: any;
  body: any;
  sender: any;
  reference: any;
  priority: any;
  communicationDate: any;
  subject: any;
  metadata: any;
  resourceUid!: string;
  msgUID!: string;
  type: any;
  rows: any;
  context: any;
  setMsgUID!: (msgUID: any) => void;
  getReplyRecipientUid!: () => string | undefined;
  senderUid: any;
  showRepondre: boolean = false;
  routePath: any;
  entityRessourceUID: any;
  statusUID: any;
  openNewTab(ressourceUID: any, statusUID: any ,context :any) {
    this.context = context;
    if(this.context === "OFFER"){
      store.dispatch("demandModule/getProposalStatus", {
      statusId: statusUID,
      callback: (result: any) => {
        this.routePath = [
          OfferStatus.DECISION,
          OfferStatus.CONTRACT,
          OfferStatus.CANCELLED,
        ].includes(result.internalCode)
          ? "/mo/demand/detail/"
          : "/demand/edit/";

        store.dispatch("demandModule/searchOffer", {
          callback: this.updateResultRows,
          filter: {
            reference: ressourceUID,
          },
        });
      },
      });
    }else if(this.context === "ORDER"){
      store.dispatch("orderModule/searchOrder", {
          callback: this.updateResultRows,
          filter: {
            notificationFilter: ressourceUID,
            role_code: "CUSTOMER"
          },
      });
    }
    
  }

  updateResultRows(rows: any) {
    let routeData;
    this.rows = rows;
    if(this.context === "OFFER"){
       routeData = router.resolve(`${this.routePath}${this.rows[0].resourceuidoffer}`);
    }else {
      routeData = router.resolve(`${'/order/edit/'}${this.rows[0].orderid}`)
    }
    window.open(routeData.href, "_blank");
  }
  showAllSelected(destinataires: { value: number; label: string }[]) {
    return destinataires.map((el) => el.value);
  }

  /**
   * This method is called when the response form is submitted.
   * updates notification status and add comment.
   */
  submitFormRepondre() {
    //
  }
  updateState!: (payload: any) => void;
  transferMessage!: (message: any) => any;

  showInner = false;

  selectedDestinataire = [];
  msgSend!: string;
  index!: number;

  showComment?: boolean = false;
  showTransfer?: boolean = false;

  cancelFormRepondre() {
    this.msgSend = "";
    this.showRepondre = false;
    this.showComment = false;
  }

  messageReplyMethode() {
    this.setMsgUID(this.msgUID);
    if (this.msgSend && this.msgSend.length > 0) {
      this.showInner = true;
      store
        .dispatch("notificationModule/messageReply", {
          resourceUid: this.msgUID,
          messageTemplate: {
            objectType: "odm.contactmechanism.messagetemplate",
            systemUid: "odm-contactmechanism",
            resourceUid: "TEMPLATE_MSG",
          },
          sender: `${store.state.authModule?.user.firstName} ${store.state.authModule?.user.lastName}`,

          senderUid: {
            objectType: "odm.user.leaseforgeuser",
            systemUid: "odm-user",
            resourceUid: `${store.state.authModule?.user?.userId}`,
          },

          priority: this.priority,
          subject: this.subject,
          type: {
            objectType: "odm.contactmechanism.messagetype",
            systemUid: "odm-contactmechanism",
            resourceUid: "MESSAGE",
          },
          body: this.msgSend,
          recipients: [
            {
              recipient: {
                objectType: "odm.user.leaseforgeuser",
                systemUid: "odm-user",
                resourceUid: this.getReplyRecipientUid(),
              },
            },
          ],
          parameters: {
            Context: this.metadata?.find((meta: any) => meta.key === "Context")?.value,
            Entity_Reference: this.metadata?.find(
              (meta: any) => meta.key === "Entity_Reference"
            )?.value,
            Entity_Status: this.metadata?.find(
              (meta: any) => meta.key === "Entity_Status"
            )?.value,
          },

          relatedObjects: null,
          clientApplication: {
            objectType: "odm.contactmechanism.contactmechanismclient",
            systemUid: "odm-contactmechanism",
            resourceUid: "68815",
          },
          objectType: objectType_odmTransferReplyMsg,
          systemUid: "odm-contactmechanism",
          daaq: "/COMPANY/BRANCH2/SALES",
        })
        .then(() => {
          this.resetMessage();
          notifyReplytransferMsg(true, "reply");
        })
        .catch((error) => {
          notifyReplytransferMsg(false, "reply");
        });
    }
  }

  /**
   * Transfer message
   */
  destinations?: [];
  getOdmRecipients!: () => recipient[];
  getNotification!: () => any;
  getParams!: () => _parameters;

  resetMessage() {
    this.msgSend = ""; // Resets the message field
    this.showRepondre = false; // Hides the reply section
    this.showInner = false; // Hides the inner section
  }

  /**
   * getting current notification (message payload)
   */
  showTransferForm(notifMsg: Notification) {
    this.showTransfer = !this.showTransfer;
   
  }
  /**
   * transfer selected message to destinations list (groups/users)
   * @param payloadTransferMsg - current notification
   */
  submitFormTransfert() {
    const payloadNotifcation: transferMsg = this.getNotification();
    //
    const _recipients: recipient[] = this.getOdmRecipients();
    for (const el of _recipients) {
      if (el.recipient && (el.recipient as any).email) {
          delete (el.recipient as any).email
      }
    }  
    //
    const _params: _parameters = this.getParams();
    //
    clientAppMsg.resourceUid = payloadNotifcation.clientApplication?.resourceUid || "";

    //
    /**
     * mapping {payloadTransferMsg}
     */
    this.showInner = true;
    const payloadTransferMsg: transferMsg = {
      messageTemplate: messageTemplate,
      sender: payloadNotifcation.sender,
      senderUid: payloadNotifcation.senderUid,
      priority: payloadNotifcation.priority,
      subject: payloadNotifcation.subject,
      type: payloadNotifcation.type,
      body: payloadNotifcation.body,
      recipients: _recipients, //*
      // TODO in the backend to convert params to metadata
      parameters: _params,
      relatedObjects: payloadNotifcation.relatedObjects,
      clientApplication: clientAppMsg, //*
      objectType: objectType_odmTransferReplyMsg,
      systemUid: payloadNotifcation.systemUid,
      daaq: payloadNotifcation.daaq,
      resourceUid: payloadNotifcation.resourceUid,
    };
    //
    this.showInner = false;
    this.transferMessage(payloadTransferMsg)
      .then(() => {
        this.showInner = false;
        notifyReplytransferMsg(true, "transfert");
        this.cancelFormTransfert();
      })
      .catch((error: any) => {
        console.error("An error occurred while transfer the message:", error);
        notifyReplytransferMsg(false, "transfert");
      });
  }

  /**
   * cancel transfer request
   */
  cancelFormTransfert() {
    this.showTransfer = false;
    this.showComment = false;
  }
  truncatedText(text: any) {
    const body = text || "";
    return body.length > 70 ? body.substring(0, 70) + '...' : body;
  }

  isLongText() {
      const body = this.getNotification().body || "";
      return body.length > 70; 
    }
}
</script>

<style scoped>
.notification {
  background-color: #f2f2f2;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}

.notification p {
  margin: 0;
}

.notification p:nth-child(2) {
  font-style: italic;
  color: #666;
}
.delete-btn {
  color: #fff;
  background-color: #f44336; /* rouge */
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  float: right;
}
.transfer-btn {
  color: #fff;
  background-color: #197ec1; /* rouge */
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  float: right;
}
.delete-btn:hover {
  background-color: #c62828; /* rouge foncé */
}
</style>
